import { useMutation, useQuery } from "@tanstack/react-query";

import { type ChangeContactAddressesPutRequest, type GetContactsResponse } from "@repo/api";
import { usePrimaryAPIClient } from "../context/PrimaryAPIClient";
import { useQueryKeyFactory } from "../context/QueryKeyProvider";

export const useContacts = () => {
    const { contactsApi } = usePrimaryAPIClient();
    const { createQueryKey } = useQueryKeyFactory();

    return useQuery<GetContactsResponse[]>({
        queryKey: createQueryKey({ key: ["getAllContacts"] }),
        queryFn: () => contactsApi.getAllContactsGet(),
    });
};

export const useChangeContactAddresses = () => {
    const { profileApi } = usePrimaryAPIClient();

    return useMutation({
        mutationFn: ({ changeContactAddressesRequest }: ChangeContactAddressesPutRequest) => {
            return profileApi.changeContactAddressesPut({
                changeContactAddressesRequest,
            });
        },
    });
};
